import(/* webpackMode: "eager" */ "/app/packages/stadium-shops-dashboard/src/app/global-error.js");
